import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as globalActions from '../../../Store/Actions/globalActions';
import '../admin/adminpage.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

 // START CLASS  //////////////////////////////////////////////////////
class TreeListSplit extends Component {
    constructor(props) {
        super(props);
        this.state = {
          
        }
    }

    componentDidMount = () =>{

    }
    //UPDATE STATE FROM PROPS
    static getDerivedStateFromProps(props, current_state) {
      // COMPUTE
      return null //STATE
    }
    // DEFAULT METHOD END /////////////////////////////
    ///////////////////////////////////////////////////




    //////////////////////////////////////////////////
    //  INNER METHOD    //////////////////////////////

    onClickSubLevelItem = (name) =>{
        this.props._update_sublevel(name);
    }





    // INNER METHOD END   /////////////////////////////
    ///////////////////////////////////////////////////



    

    //////////////////////////////////////////////////
    //  RENDER METHOD   //////////////////////////////
    buildContent = () =>{
        var innerContent = this.props.listSelector.map((item,i)=>
        {
          return (
            <div key={i} className="sublevelItem" onClick={this.onClickSubLevelItem.bind(this,item.name)}>
              <div className="item-icon"><FontAwesomeIcon icon={item.icon}/></div>
              <div className="item-header">{item.name}</div>
            </div>
          )
        });


      return(
        <div className="sublevelSelector">
          {innerContent}
        </div>
      );
    }

    // RENDER METHOD END //////////////////////////////
    ///////////////////////////////////////////////////

    render() {
        var content = this.buildContent();
    
        return (content);
    }
   
}
 // END CLASS  //////////////////////////////////////////////////////




////////////////////////////////////////////////////////////////////
//////////////            REDUX              ///////////////////////
////////////////////////////////////////////////////////////////////
const mapStateToProps = (state) => {
  return {
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    _update_sublevel:(name) =>dispatch(globalActions.update_sublevel(name)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TreeListSplit);

